import * as React from 'react';
import DatePicker from '../DatePicker';

import * as moment from 'moment';
// import { __extends } from "tslib";
import { DEFAULT_TIME_FORMAT } from '../../common/constants';
import classNames from 'classnames';

export default class EditDiaryDueDate extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            diaryData:{}
        }

        this.handleChange = this.handleChange.bind(this);
        this.onSaveBtnClick = this.onSaveBtnClick.bind(this);
        this.onCancelBtnClick = this.onCancelBtnClick.bind(this);
    }

    componentDidMount(){
        this.setState({
            diaryData:this.props.data
        })
    }

    handleChange(data) {
        const newState = Object.assign(
            {},
            this.state.diaryData,
            {
                strDueDate: moment(data).format(DEFAULT_TIME_FORMAT)
            }
        );

        this.setState({
            diaryData: newState
        });
    }

    onSaveBtnClick(comment) {
        var tmp_date = Object.assign({}, this.state.diaryData);
        const payload = {
            cid: tmp_date['Id'],
            updatedDuedate: tmp_date['strDueDate'],
            comment: comment
        }
        tmp_date['strDueDate'] = tmp_date['strDueDate'].replace(",", " at ");
        if (this.props.onSaveBtnClick) {
            this.props.onSaveBtnClick(Object.assign({}, tmp_date), payload);
        }
    }

    onCancelBtnClick() {
        if (this.props.onCancelBtnClick) {
            this.props.onCancelBtnClick();
        }
    }

    render() {
        const {data}=this.props;
        const date =(data.strDueDate).replace(" at ",",")
        return (
            <div className="">
                <DatePicker
                    customInput = {<CustomDueDateLabel/>}
                    selectedDate= { moment(date) }
                    calendarClass = { 'change-diary-due-date-inline' }
                    className={this.props.className}
                    onChange={this.handleChange}
                    calendarClassName="animated faster fadeInUpx2"
                    openToDate={ moment(date)}
                    myContainer={true}
                    showComment={true}
                    showTimePicker={true}
                    timeIntervals={15}
                    shouldCloseOnSelect={false}
                    dateFormat={DEFAULT_TIME_FORMAT}
                    onConfirmClick={ (comment) => { this.onSaveBtnClick(comment)} }
                    popperPlacement='bottom-start'
                    popperModifiers={{
                        flip: {
                            behavior: ['bottom'] // don't allow it to flip to be above
                        },
                        preventOverflow: {
                            enabled: false // tell it not to try to stay within the view (this prevents the popper from covering the element you clicked)
                        },
                        hide: {
                            enabled: false // turn off since needs preventOverflow to be enabled
                        }
                    }}
                />
                <span className="error_msg"></span>
            </div>
        );
    }
}

class CustomDueDateLabel extends React.Component {

    render () {
      return (
          <button onClick={this.props.onClick} className="diarydueDate">
            <label className="labelDueDate">Due Date</label>{this.props.value}
          </button>
      )
    }
  }